const gray = {
    gray50: '#f9fafb',
    gray100: '#f2f4f6',
    gray200: '#e5e8eb',
    gray300: '#d1d6db',
    gray400: '#b0b8c1',
    gray500: '#8b95a1',
    gray600: '#6b7684',
    gray700: '#4e5968',
    gray800: '#333d4b',
    gray900: '#191f28',
};

const blue = {
    blue50: '#ECEEFF',
    blue100: '#D9DEFF',
    blue200: '#BFC7F6',
    blue300: '#A5B1ED',
    blue400: '#8B9BE3',
    blue500: '#6673BB',
    blue600: '#535D9B',
    blue700: '#40477B',
    blue800: '#2D315B',
    blue900: '#1A1B3B',
};

const red = {
    red50: '#FFECEC',
    red100: '#FFD9D9',
    red200: '#F6BFC7',
    red300: '#EDA5B1',
    red400: '#E38B9B',
    red500: '#BB6673',
    red600: '#9B535D',
    red700: '#7B4047',
    red800: '#5B2D31',
    red900: '#3B1A1B',
};

const green = {
    green50: '#ECFFEC',
    green100: '#D9FFD9',
    green200: '#C7F6BF',
    green300: '#B1EDA5',
    green400: '#9BE38B',
    green500: '#73BB66',
    green600: '#5D9B53',
    green700: '#478040',
    green800: '#315B2D',
    green900: '#1B3B1A',
};

const common = {
    blueText: '#4184FC',
    redText: '#DC4A43',
};

export const lightTheme = {
    themeColor: '#FFFFFF',
    reverseThemeColor: 'var(--gray900)',
    textBase: '#000000',
    textInactive: '#999999',
    borderBase: '#DADADA',
    reverseBackgroundBase: '#000000',
    reverseTextBase: '#FFFFFF',

    background: '#FFFFFF',
    backgroundBase: '#f1f1f1',
    backgroundSecondary: '#f7f7f7',
    backgroundItemHover: 'rgba(0, 0, 0, 0.1)',
    textComment: '#777777',

    textPrimary: 'var(--gray900)',
    textSecondary: 'var(--gray800)',
    textTertiary: 'var(--gray700)',
    textQuaternary: 'var(--gray600)',
    textDisabled: 'var(--gray500)',

    backgroundPrimary: 'var(--gray50)',
    backgroundTertiary: 'var(--gray200)',

    borderPrimary: 'var(--gray300)',
    borderSecondary: 'var(--gray200)',
    borderTertiary: 'var(--gray100)',

    ...common,
    ...gray,
    ...blue,
    ...red,
    ...green,
};

export const darkTheme = {

    ...blue,
    ...red,
    background: '#000000',
    backgroundSub: '#1c1c1e',
    textBase: '#FFFFFF',
    blue: '#1A80E5',
    skyblue: '#90C7FF',
    middlegray: '#D9D9D980',
    lightgray: '#E8EDF2',
    darkgray: '#717171',
    deepdarkgray: '#2F2F2F',
    dark: '#0D141C',
    borderBase: '#ffffff',

    green: '#9FE77C',
    yellow: '#FCD838',
    red: '#FF6161',
    gray: '#D9D9D9',

    mainGlassSolid: 'linear-gradient(135deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.50) 100%)',
    mainBlue: 'linear-gradient(180deg, rgba(118, 214, 255, 1) 0%, rgba(60, 126, 255, 1) 100%)',
    subBlue: 'linear-gradient(30deg, rgba(118, 214, 255, 1) 0%, rgba(60, 126, 255, 1) 100%)',
    subJinBlue: 'linear-gradient(180deg, #5FB6FB -8.53%, #3369F9 44.72%)',
    whiteSolid: 'linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.2) 100%)',
    mainRed: 'linear-gradient(106deg, rgba(255, 153, 0, 0.80) 8.98%, rgba(255, 0, 77, 0.80) 94.82%), linear-gradient(180deg, #F00 0%, #F00 100%)',
    mainGreen: 'linear-gradient(164deg, #75EDA1 -5.03%, #349256 122.7%)',
    mainYellow: 'linear-gradient(180deg, #F8DC19 0%, #FD9903 100%)',
    mainOrange: 'linear-gradient(197deg, rgba(253, 133, 2, 0.80) 6.28%, rgba(239, 70, 3, 0.80) 93.5%)',
    mainPurple: 'linear-gradient(196deg, rgba(189, 0, 255, 1) 0%, rgba(145, 2, 200, 1) 100%)',
    mainPink: 'linear-gradient(154deg, #FF76AB 3.78%, #DC2169 66.47%)',
    searchSolid: 'linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.03) 100%)',
};
